import { useState, useEffect } from "react";
import { services } from "../../api";
import { Land, LandsListContent } from "../../interfaces/api/lands";

interface UseFeaturedLandsResult {
  featuredLands: Land[];
  loading: boolean;
  error: string | null;
  fetchFeaturedLands: () => Promise<void>;
}

export const useFeaturedLands = (): UseFeaturedLandsResult => {
  const [featuredLands, setFeaturedLands] = useState<Land[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFeaturedLands = async (): Promise<void> => {
    try {
      setLoading(true);
      setError(null);

      // Add a small delay to make the loading state more visible for testing
      // Remove this in production
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const response = await services.lands.getFeaturedLands();
      const content = response.content as LandsListContent;

      setFeaturedLands(content.data);
    } catch (err) {
      setError("Failed to fetch featured lands");
      console.error("Error fetching featured lands:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeaturedLands();
  }, []);

  return {
    featuredLands,
    loading,
    error,
    fetchFeaturedLands,
  };
};
